import { useMutation, useQueryClient } from '@tanstack/react-query';
import authApi from '../api/authApi';
import { queryKeys } from './queryKeys';

export const useAddArtist = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (artistData) => {
      const response = await authApi.post('/artists', artistData);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.artists.all() });
    },
  });
};

export const useUpdateArtist = (artistId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data) => {
      const response = await authApi.post(`/artists/${artistId}`, data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.artists.all() });
      queryClient.invalidateQueries({ queryKey: queryKeys.artists.detail(artistId) });
    },
  });
};

export const useDeleteArtist = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id) => {
      const response = await authApi.delete(`/artists/${id}`);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.artists.all() });
    },
  });
};
